import Suggestion from "./Suggestion";
import Socrates from "./Socrates";
import Result from "./Result";
import Period from "./Period";

export type { CardSuggestionProps } from "./Suggestion";
export type { CardSocratesProps } from "./Socrates";
export type { CardResultProps } from "./Result";
export type { CardPeriodProps } from "./Period";

const Card = {
  Suggestion,
  Socrates,
  Result,
  Period,
};

export default Card;

// 개별 import 지원 (하위 호환성)
export {
  Suggestion as CardSuggestion,
  Socrates as CardSocrates,
  Result as CardResult,
  Period as CardPeriod,
};
